import { combineReducers } from "redux"
import { reducer as formReducer } from "redux-form"
import { routerReducer } from "react-router-redux"
import { reducer } from 'redux-oidc'
import modals from "../ducks/modals"
import { reducer_forms } from './reducer_forms'
import user from './reducer_user'


// import ui from "ducks/ui";
export const reducers = combineReducers({
  modals,
  form: formReducer.plugin(reducer_forms),
  routing: routerReducer,
  oidc:reducer,
  user
})



// WEBPACK FOOTER //
// ./src/redux/reducers/index.js